// NATIVE 
import { useState } from 'react';

// INSTALLED 
import { useFormikContext } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import { Alert, Button, Card, Divider, Grid, Typography } from '@mui/material';


// CUSTOM 
import { uploadPdfStore } from '../../../store/uploaders';
import AutocompleteField from '../../formFields/autocompleteField';
import { UploadButtonField } from '../../formFields/uploadButtonField';
import { LinearProgressWithLabel } from '../../LinearProgressWithLabel';
import InputField from '../../formFields/InputField';


export const SeguridadSocial = (props:any) => {


  const dispatch = useDispatch();

  const formikProps:any = useFormikContext();

  const [percentage_upload_cc, setPercentageUploadCc]   = useState(0);
  const [percentage_upload_cs, setPercentageUploadCs]   = useState(0);
  const [percentage_upload_al, setPercentageUploadAl]   = useState(0);


    // REDUX
    const  {  eps_list, eps_list_select }:any  = useSelector( (state:any) => state.eps );
    const  {  family_compensation_list, family_compensation_list_select }:any  = useSelector( (state:any) => state.cajaCompensacion );
    const  {  cesantias_list, cesantias_list_select }:any  = useSelector( (state:any) => state.cesantias );
    const  {  pension_list, pension_list_select }:any  = useSelector( (state:any) => state.pension );


    

    const { formField: {
      // DATOS CLIENTE 
      eps,
      familyCompensation,
      fileCajaCompensacion,
      cesantias,
      fileCesantias,
      pension,
      fileArl
    }
  } = props;
   


  const uploadCajaCompensacion = async ({ target }:any) => {

    formikProps.setFieldValue('fileCajaCompensacion', target.files[0]);
    const { ok, data } = await dispatch( uploadPdfStore( 'caja-compensacion-empleado', target.files[0], setPercentageUploadCc) );
    
    if (ok) {
      formikProps.setFieldValue('caja_compensacion_name_saved', data.pdfName);
    }

  }


  const uploadCesantias = async ({ target }:any) => {

    formikProps.setFieldValue('fileCesantias', target.files[0]);
    const { ok, data } = await dispatch( uploadPdfStore( 'cesantias-empleado', target.files[0], setPercentageUploadCs) );
    
    if (ok) {
      formikProps.setFieldValue('cesantias_name_saved', data.pdfName);
    }

  }


  const uploadArl = async ({ target }:any) => {

    formikProps.setFieldValue('fileArl', target.files[0]);
    const { ok, data } = await dispatch( uploadPdfStore( 'arl-empleado', target.files[0], setPercentageUploadAl) );
    
    if (ok) {
      formikProps.setFieldValue('arl_name_saved', data.pdfName);
    }

  }


  return (

    
    <>
    
        <Typography variant='h6' sx={{ fontWeight: 'bold', marginTop: 7, marginBottom: 4 }}> Información de Seguridad Social </Typography>

        <Grid container spacing={2}>

            <Grid item xs={3}>


              {
                                              
                    ( eps_list_select && eps_list_select.length > 0 )
    
                        ?
    
                        <AutocompleteField  
                          options={eps_list_select}
                          name={eps.name}
                          label={eps.label}
                          element={eps.name}
                        />
    
                        :
                        <InputField
                          disabled
                          error
                          name={'N/A'}
                          label={'Debes crear Las eps*'}
                          variant="outlined" 
                          fullWidth
                        />
              }

                
            </Grid>


            <Grid item xs={3}>
              
            </Grid>
            

            <Grid item xs={3}>

            {
                                              
                    ( family_compensation_list_select && family_compensation_list_select.length > 0 )
    
                        ?
    
                        <AutocompleteField 
                          options={family_compensation_list_select}
                          name={familyCompensation.name}
                          label={familyCompensation.label}
                          element={familyCompensation.name}
                        />
    
                        :
                        <InputField
                          disabled
                          error
                          name={'N/A'}
                          label={'Debes crear caja de compensacion*'}
                          variant="outlined" 
                          fullWidth
                        />
            }

                
            </Grid>

           
            <Grid item xs={3}>
               <UploadButtonField accept={'application/pdf'} 
                                  name={fileCajaCompensacion.name} 
                                  label={fileCajaCompensacion.label} 
                                  text={'Caja de compensacion'} 
                                  onChange={uploadCajaCompensacion}/>

                {
                  formikProps.values.fileCajaCompensacion 
                       ?
                        <Card variant="elevation" sx={{  marginTop: 1.5, padding: 1, height: '70%',  }}>
                         <LinearProgressWithLabel percentage={percentage_upload_cc} label={formikProps.values.fileCajaCompensacion.name} hasIcon={true} /> 
                        </Card>
                       :
                       ''
                }
            </Grid>
            


        </Grid>
        {/* END GRID  */}



        <Divider style={{ marginTop: 25 }}/>
        <Typography variant='h6' sx={{ fontWeight: 'bold', marginTop: 7, marginBottom: 4 }}> Pensiones y Cesatias </Typography>

        <Grid container spacing={2}>

          <Grid item xs={3}>

              {
                                              
                    ( cesantias_list_select && cesantias_list_select.length > 0 )
    
                        ?
    
                        <AutocompleteField 
                          options={cesantias_list_select}
                          name={cesantias.name}
                          label={cesantias.label}
                          element={cesantias.name}
                        />
    
                        :
                        <InputField
                          disabled
                          error
                          name={'N/A'}
                          label={'Debes crear Las cesantias*'}
                          variant="outlined" 
                          fullWidth
                        />
              }

              
          </Grid>

          <Grid item xs={3}>
            <UploadButtonField accept={'application/pdf'} 
                                name={fileCesantias.name} 
                                label={fileCesantias.label} 
                                text={'Cesantias'} 
                                onChange={uploadCesantias}/>
                {
                  formikProps.values.fileCesantias 
                       ?
                        <Card variant="elevation" sx={{  marginTop: 1.5, padding: 1, height: '70%',  }}>
                         <LinearProgressWithLabel percentage={percentage_upload_cc} label={formikProps.values.fileCesantias.name} hasIcon={true} /> 
                        </Card>
                       :
                       ''
                }
          </Grid>

          <Grid item xs={3}></Grid>

          <Grid item xs={3}>


          {
                                              
                ( cesantias_list_select && cesantias_list_select.length > 0 )

                    ?

                    <AutocompleteField 
                      options={pension_list_select}
                      name={pension.name}
                      label={pension.label}
                      element={pension.name}
                    />

                    :
                    <InputField
                      disabled
                      error
                      name={'N/A'}
                      label={'Debes crear Las pensiones*'}
                      variant="outlined" 
                      fullWidth
                    />
          }
          
              
          </Grid>

        </Grid>
        {/* END GRID  */}


        <Divider style={{ marginTop: 25 }}/>
        <Typography variant='h6' sx={{ fontWeight: 'bold', marginTop: 7, marginBottom: 4 }}> Arl </Typography>

        <Grid container spacing={2}>


          <Grid item xs={3}>
            <UploadButtonField accept={'application/pdf'} 
                                name={fileArl.name} 
                                label={fileArl.label} 
                                text={'Arl'} 
                                onChange={uploadArl}/>
                {
                  formikProps.values.fileArl 
                       ?
                        <Card variant="elevation" sx={{  marginTop: 1.5, padding: 1, height: '70%',  }}>
                         <LinearProgressWithLabel percentage={percentage_upload_cc} label={formikProps.values.fileArl.name} hasIcon={true} /> 
                        </Card>
                       :
                       ''
                }
          </Grid>


        </Grid>
        {/* END GRID  */}


       

    </> 
  )
}
